import { useSelector } from 'react-redux';
import { selectCompanies, selectDefaultCompanyId } from '../redux/selectors';

export function useSelectCompanyInfo() {
  const entities = useSelector(selectCompanies);
  const defaultEntityId = useSelector(selectDefaultCompanyId);
  return { entities, defaultEntityId };
}
